import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';
import { delay, tap } from 'rxjs/operators';

@Directive({
    selector: '[libMarkCommentAsRead]',
    standalone: false
})
export class MarkCommentAsReadDirective
  extends AliveState
  implements OnInit, OnDestroy
{
  @Input() commentDate;
  @Input() emitOnEntrance = new Subject();
  observer: IntersectionObserver;
  shouldEmit$ = new Subject();

  constructor(private elementRef: ElementRef) {
    super();
  }

  ngOnInit(): void {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    };

    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.shouldEmit$.next(this.commentDate);
      }
    }, options);
    this.observer.observe(this.elementRef.nativeElement);
    this.subscribeWhileAlive(
      this.shouldEmit$.pipe(
        delay(2000),
        tap((x) => this.emitOnEntrance.next(x))
      )
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.observer.disconnect();
  }
}
